<script setup lang="ts">
import { NavigationMenuItem } from '../navigation-menu'
import { useMediaQuery } from '../utils/use-media-query'

const isDesktop = useMediaQuery('md')
</script>

<template>
  <!-- Desktop Menu Item -->
  <NavigationMenuItem v-if="isDesktop">
    <slot />
  </NavigationMenuItem>
  <!-- Mobile Menu Item -->
  <slot v-else />
</template>
